<template>
  <div class="Jj_annex_block">
    <!-- 上传进度条 -->
    <div class="progress-container" v-if="showPercent">
      <div class="progress-row">
        <div class="progress-info">
          <el-progress text-color="#fff" :text-inside="true" :stroke-width="18" :percentage="percentNum"></el-progress>
          <div class="file-status">
            {{ curFile.fileType || '文件' }} 上传中...
          </div>
        </div>
        <i class="el-icon-error cancel-upload" @click="cancelUpload"></i>
      </div>
    </div>

    <!-- 下载进度条 -->
    <div class="progress-container" v-if="showDownloadPercent">
      <div class="progress-row">
        <div class="progress-info">
          <el-progress text-color="#fff" :text-inside="true" :stroke-width="18"
            :percentage="downloadPercentNum"></el-progress>
          <div class="file-status">
            {{ currentDownloadItem?.fileType || currentDownloadItem?.fileName || '文件' }} 下载中...
          </div>
        </div>
        <i class="el-icon-error cancel-download" @click="cancelDownload"></i>
      </div>
    </div>

    <!-- 文件展示区域 -->
    <template v-else-if="!showPercent && !showDownloadPercent">
      <div class="file-card" v-for="(item, index) in fileList" :key="index"
        @mouseenter="$emit('annex-mouseenter', item.fileType)">
        <!-- 已上传文件 -->
        <div class="file-box" v-if="item.filePath">
          <img class="certified-mark" :src="jiaobiao" alt="已认证标识" />

          <!-- PDF预览 -->
          <div v-if="isPDF(item.filePath)" class="pdf-container">
            <iframe class="pdf-preview" :src="getFullFilePath(item.filePath)" frameborder="0"></iframe>
          </div>

          <!-- 图片或文件图标 -->
          <img v-else class="file-thumbnail" :src="iconShow(item.filePath)" alt="文件预览" />

          <!-- 悬停操作菜单 -->
          <div class="file-overlay">
            <div class="action-buttons">
              <span @click="viewFile(item)" v-if="isPreview(item, item.filePath)" class="btn-preview">
                <el-tooltip effect="dark" placement="top">
                  <div slot="content">
                    {{ item.fileName }}
                  </div>
                  <span>
                    <i class="el-icon-view"></i> 预览
                  </span>
                </el-tooltip>
              </span>
              <span @click="downloaFile(item)" class="btn-download">
                <i class="el-icon-download"></i> 下载
              </span>
              <span @click="delFile(item)" v-if="isUpload" class="btn-delete">
                <i class="el-icon-delete"></i> 删除
              </span>
            </div>
          </div>
        </div>

        <!-- 上传区域 -->
        <div class="file-box upload-area" v-else @click="changeFile(item)"
          v-loading="loading && item.fileType == curFile.fileType ? true : false" element-loading-text="上传中...">
          <i :class="isUpload ? 'el-icon-upload' : 'el-icon-lock'"></i>
          <p v-if="isUpload" class="upload-text">点击上传</p>
          <!-- <p class="format-tip">格式：{{ item.limitingType?.join("、") }}</p> -->
          <el-tooltip effect="dark" :content="item.limitingType?.join('、')" placement="top">
            <p class="format-tip">格式：{{ item.limitingType?.join("、") }}</p>
          </el-tooltip>
          <p class="size-tip">大小：{{ "小于" + item.size + "M" }}</p>
        </div>
        <!-- 文件名称 -->
        <div class="file-name" :title="item.fileType" :class="{ required: item.required }">
          <span v-if="item.required" class="required-mark">*</span>
          {{ item.fileType }}
        </div>
      </div>
    </template>

    <!-- 文件上传组件(隐藏) -->
    <el-upload class="upload-demo" v-show="false" ref="uploadFile" action="#" :auto-upload="false" :on-change="onChange"
      :on-error="onError"></el-upload>

    <!-- 竣工结算成果文件上传提示对话框 -->
    <el-dialog title="金建提示" :visible.sync="showUploadTipDialog" width="600px" :modal-append-to-body="false"
      :close-on-click-modal="false" :close-on-press-escape="false" custom-class="upload-tip-dialog">
      <div class="tip-content">
        <p class="tip-message">
          确保上传文件中包含标准接口文件（TBS/TBS4/SXTB/SXTB4/XATB）！
        </p>
        <p class="tip-message">
          已包含点击"确认"继续上传，未包含点击"取消"修改后上传！
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleUploadTipCancel">取 消</el-button>
        <el-button type="primary" @click="handleUploadTipConfirm">确 认</el-button>
      </span>
    </el-dialog>

    <el-drawer :title="curAnnex.fileType" class="review-divider" :visible.sync="drawer" :modal="false" size="70%"
      :before-close="handleClose" :append-to-body="true">
      <div class="drawer-container">
        <div class="left">
          <iframe class="pdf-preview" v-if="isPdf && curAnnex.filePath && curAnnex.filePath.length"
            :src="getFullFilePath(curAnnex.filePath)" frameborder="0" width="100%" height="100%"></iframe>
          <div class="empty" v-else>{{ emptyText }}</div>

        </div>
        <div class="right">
          <span class="title">附件信息</span>
          <el-divider border-style="dashed" />
          <el-menu :default-active="curAnnex.fileType" @select="handleSelect">
            <el-menu-item v-for="item in fileList" :key="item.fileType" :index="item.fileType">
              <span slot="title">{{ item.fileType }}</span>
              <i v-if="item.filePath" class="el-icon-success" style="color: #67C23A;"></i>
              <i v-else class="el-icon-warning" style="color: #E6A23C;"></i>
            </el-menu-item>
          </el-menu>
          <span class="title">附件预览</span>
          <el-divider border-style="dashed" />
          <JjAnnexBlock :annexList="[curAnnex]" :isUpload="isUpload" @saveFile="(params, callback
          ) => { emitAsync('saveFile', params); callback(); }" @delFile="(params) => { $emit('delFile', params) }"
            :isOldWiewFile="true">
          </JjAnnexBlock>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import config from "@/config";
import { uploadFile, cancel } from "@/util/sliceUploaded";
import { showViewImgDialog, downloadUrl } from "@/util/utils";
const imgArr = ["jpg", "png", "jpeg"];
import { mapState, mapGetters } from "vuex";
import { downloadUrlWithProgress, cancelDownload } from '@/util/utils'
import pdf from 'pdfvuer'
export default {
  name: "JjAnnexBlock",
  components: { pdf },
  props: {
    annexList: { type: Array, default: () => [] },
    isUpload: { type: Boolean, default: false },
    otherPreview: { type: Boolean, default: false },
    isOldWiewFile: { type: Boolean, default: false }
  },
  data() {
    return {
      config,
      viewVisible: false,
      drawer: false,
      viewTitle: "",
      pdfUrl: "",
      fileList: [],
      curFile: {},
      showPercent: false,
      percentNum: 0,
      loading: false,
      jiaobiao: require("@/assets/images/icon/jiaobiao.png"),
      curAnnex: {},
      emptyText: '暂无附件',
      // 下载相关数据
      showDownloadPercent: false,
      downloadPercentNum: 0,
      currentDownloadItem: null,
      downloadController: null,
      downloadTaskId: null,
      // 竣工结算成果文件上传提示
      showUploadTipDialog: false,
      pendingUploadFile: null,
      pendingUploadFileList: null
    };
  },
  created() { },
  mounted() { },
  computed: {
    ...mapState(["percent"]),
    isPdf: function () {
      if (this.curAnnex && this.curAnnex.filePath) {
        return this.isPreview(this.curAnnex, this.curAnnex.filePath)
      }
    }
  },
  watch: {
    percent(v) {
      this.percentNum = v;
    },
    annexList: {
      deep: true,
      immediate: true,
      handler(list = []) {
        if (this.isUpload) {
          this.fileList = list;
        } else {
          this.fileList = list.filter(item => item.filePath);
        }
        if (this.fileList.length) {
          const target = this.fileList.find(item => {
            return item.fileType == this.curAnnex.fileType
          });
          if (target) {
            // this.curAnnex = target
            this.handleSelect(target.fileType)
          }
        }
      }
    }
  },
  beforeDestroy() {
    this.$store.commit("stopUpload", true);
    // 清理下载任务
    this.cancelDownload();
  },
  methods: {
    isPDF(v) {
      return /\.pdf$/gi.test(v);
    },
    getFullFilePath(url) {
      return config.baseUrl + url;
    },
    // 失败
    onError(err, file, fileList) {
      setTimeout(() => {
        this.$message.warning("当前网络拥堵，请重新上传！");
      }, 1500);
    },
    onChange(file, fileList) {
      // 限制文件名长度
      if (file.name.length > 255) {
        this.$message.warning(`文件名超过255位字符，请重新命名后上传！`);
        return false;
      }
      // 限制格式
      let urlType = file.name.match(/[^.]+$/)[0].toLowerCase();
      let format = this.curFile.limitingType.map(item => item.toLowerCase());

      if (!format.includes(urlType)) {
        this.$message.warning(
          `格式错误，请上传【${format.join("、")} 】格式的文件`
        );
        return false;
      }

      // 限制大小
      const size = file.size / 1024 / 1024 > Number(this.curFile.size);
      if (size) {
        this.$message.warning(`文件大小不能超过【${this.curFile.size}MB】!`);
        return false;
      }

      // 检查是否为竣工结算成果文件且上传的是zip格式
      if (this.curFile.fileType === '竣工结算成果文件' && urlType === 'zip') {
        // 暂存文件，显示提示对话框
        this.pendingUploadFile = file;
        this.pendingUploadFileList = fileList;
        this.showUploadTipDialog = true;
        return false;
      }

      // 继续上传流程
      this.doUpload(file, fileList);
    },
    async emitAsync(event, ...args) {
      return new Promise(resolve => {
        this.$emit(event, ...args, resolve);
      });
    },
    // 取消上传
    async cancelUpload() {
      const flag = await this.$asyncConfirm("确认取消上传吗?");
      if (flag == "confirm") {
        this.showPercent = false;
        this.loading = false;
        this.$store.commit("stopUpload", true);
        setTimeout(async () => {
          await cancel();
        }, 500);
      }
    },
    // 选择文件
    changeFile(item) {
      if (this.loading) return;
      this.curFile = item;
      if (this.isUpload) {
        this.$refs.uploadFile.$refs["upload-inner"].handleClick();
      }
    },
    // 只有pdf和图片可以预览
    isPreview(item, url) {
      let type = url.match(/[^.]+$/)[0].toLowerCase();
      let img = imgArr.includes(type);
      if (type == "pdf" || img) return true;
    },
    // 显示文件图标
    iconShow(url) {
      if (url.match(/[^.]+$/)) {
        let type = url.match(/[^.]+$/)[0].toLowerCase();
        if (imgArr.includes(type)) {
          return this.getFullFilePath(url);
        } else {
          switch (type) {
            case "rar":
            case "zip":
              return require("@/assets/images/file/zip.png");
            case "excel":
              return require("@/assets/images/file/Excel.png");
            case "word":
              return require("@/assets/images/file/word.png");
            default:
              return require("@/assets/images/file/default.png");
          }
        }
      }
    },
    // 下载
    downloaFile(item) {
      this.$confirm(`确定下载【${item.fileType}】附件吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      }).then(async () => {
        this.startDownload(item);
      });
    },
    // 开始下载文件（带进度）
    async startDownload(item) {
      if (this.showDownloadPercent) {
        this.$message.warning("请等待当前下载任务完成");
        return;
      }

      this.currentDownloadItem = item;
      this.downloadPercentNum = 0;
      this.showDownloadPercent = true;

      // 生成下载任务ID
      this.downloadTaskId = `download-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

      try {
        const fileUrl = this.getFullFilePath(item.filePath);
        const fileName = item.fileName || item.fileType;

        await downloadUrlWithProgress(
          fileUrl,
          fileName,
          this.downloadTaskId,
          this.onDownloadProgress
        );

        this.$message.success("下载完成");
      } catch (error) {
        if (error.message !== '下载已被取消') {
          this.$message.error('下载失败: ' + error.message);
        }
      } finally {
        this.resetDownloadState();
      }
    },
    // 下载进度回调
    onDownloadProgress(progressEvent, id) {
      const percent = (progressEvent.loaded / progressEvent.total) * 100;
      this.downloadPercentNum = Number(percent.toFixed(2));
    },
    // 取消下载
    async cancelDownload() {
      if (!this.showDownloadPercent) return;

      const flag = await this.$asyncConfirm("确认取消下载吗?");
      if (flag == "confirm") {
        if (this.downloadTaskId) {
          cancelDownload(this.downloadTaskId);
        }
        this.resetDownloadState();
        this.$message.success("下载已取消");
      }
    },
    // 重置下载状态
    resetDownloadState() {
      this.showDownloadPercent = false;
      this.downloadPercentNum = 0;
      this.currentDownloadItem = null;
      this.downloadTaskId = null;
    },
    // 预览
    viewFile(item) {
      if (this.isPDF(item.filePath)) {
        this.pdfUrl = this.getFullFilePath(item.filePath);

        if (this.isOldWiewFile) {
          window.open(this.pdfUrl);
        } else {
          this.drawer = true;
          // item.filePath = this.getFullFilePath(item.filePath);
          this.curAnnex = item
        }
      } else {
        showViewImgDialog(this.getFullFilePath(item.filePath));
      }
    },
    // 删除
    delFile(item) {
      this.$confirm(`确定删除【${item.fileType}】附件吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        this.$emit("delFile", item);
      });
    },
    handleClose(done) {
      done();
    },
    handleSelect(key, keyPath) {
      this.pdfUrl = ''
      this.emptyText = '暂无附件'
      const target = this.fileList.find((item) => item.fileType == key);
      if (target.filePath) {
        const isPreview = this.isPreview(target, target.filePath);
        if (isPreview) {
          this.viewFile(target);
        } else {
          this.emptyText = '非PDF文件无法预览'
        }
      }
      this.curAnnex = target
    },
    // 确认上传提示
    handleUploadTipConfirm() {
      this.showUploadTipDialog = false;
      if (this.pendingUploadFile) {
        this.doUpload(this.pendingUploadFile, this.pendingUploadFileList);
        this.pendingUploadFile = null;
        this.pendingUploadFileList = null;
      }
    },
    // 取消上传提示
    handleUploadTipCancel() {
      this.showUploadTipDialog = false;
      this.pendingUploadFile = null;
      this.pendingUploadFileList = null;
      // 清空上传组件
      this.$refs.uploadFile.clearFiles();
    },
    // 执行上传
    doUpload(file, fileList) {
      // 大于5M出现进度条
      if (file.size > 5 * 1024 * 1024) {
        this.showPercent = true;
      }

      this.loading = true;
      let params = {};
      uploadFile(file, params).then(async res => {
        // 切片未成功
        if (!res) {
          setTimeout(() => {
            this.showPercent = false;
            this.loading = false;
          }, 1000);
          return;
        }
        this.percentNum = res.progress;

        setTimeout(async () => {
          try {
            const query = {
              fileId: res.fileId,
              fileName: res.originName,
              fileType: this.curFile.fileType,
              fileUrl: res.url,
              md5: res.md5,
              backEndFileName: res.fileName
            };
            await this.emitAsync("saveFile", query);
          } catch (error) {
            console.log(error);
          } finally {
            this.showPercent = false;
            this.loading = false;
            this.$store.commit("percent", -1);
          }
        }, 500);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.Jj_annex_block {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 10px;
  width: 100%;
  padding: 20px 0;
  box-sizing: border-box;
}

// 文件卡片样式
.file-card {
  display: flex;
  flex-direction: column;
  width: 160px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-4px);
  }

  .file-name {
    width: 100%;
    margin-top: 12px;
    padding: 0 5px;
    text-align: center;
    color: #165dff;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
    transition: color 0.2s ease;

    &:hover {
      color: #0E42D2;
    }
  }

  .required-mark {
    color: #ff4d4f;
    margin-left: 3px;
  }
}

// 文件框样式
.file-box {
  position: relative;
  width: 100%;
  height: 180px;
  border: 1px dashed #c9cdcf;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

  &:hover {
    border-color: #165dff;
    box-shadow: 0 4px 12px rgba(22, 93, 255, 0.15);
  }

  .certified-mark {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    width: 26px;
    transition: opacity 0.3s ease;
    opacity: 0.9;
  }

  // PDF预览容器
  .pdf-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;

    .pdf-preview {
      width: calc(100% + 21px);
      height: 100%;
      margin: -1px 0 0 -2px;
      transition: all 0.3s ease;
    }
  }

  // 文件缩略图
  .file-thumbnail {
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: 15px;
    box-sizing: border-box;
    transition: transform 0.3s ease, filter 0.3s ease;

    &:hover {
      transform: scale(1.03);
      filter: brightness(1.05);
    }
  }

  // 悬停遮罩
  .file-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    opacity: 0;
    transition: opacity 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(2px);

    &:hover {
      opacity: 1;
    }
  }

  // 操作按钮
  .action-buttons {
    width: 100%;
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    box-sizing: border-box;
    transform: translateY(10px);
    transition: transform 0.3s ease;

    .file-overlay:hover & {
      transform: translateY(0);
    }
  }

  .btn-preview,
  .btn-download,
  .btn-delete,
  .btn-format {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 6px 0;
    color: #fff;
    font-size: 14px;
    border-radius: 4px;
    transition: all 0.2s ease;
    background-color: rgba(255, 255, 255, 0.1);

    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
      transform: translateX(3px);
    }
  }

  .btn-delete {
    color: #ffd7d9;

    &:hover {
      background-color: rgba(255, 77, 79, 0.25);
    }
  }
}

// 上传区域样式
.upload-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #86909c;
  background-color: #fafafa;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(22, 93, 255, 0.05), transparent);
    transition: all 0.6s ease;
  }

  &:hover::before {
    left: 100%;
  }

  i {
    font-size: 32px;
    margin-bottom: 10px;
    color: #165dff;
    transition: transform 0.3s ease, color 0.3s ease;
  }

  &:hover {
    background-color: #f5f7fa;
    border-color: #165dff;

    i {
      transform: scale(1.1) rotate(5deg);
      color: #0E42D2;
    }
  }

  .upload-text {
    font-size: 14px;
    margin-bottom: 8px;
    color: #165dff;
    font-weight: 500;
    transition: color 0.3s ease;
  }

  &:hover .upload-text {
    color: #0E42D2;
  }

  .format-tip,
  .size-tip {
    font-size: 12px;
    color: #86909c;
    margin: 3px 0;
    text-align: center;
    padding: 0 5px;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
}

// 进度条样式（上传和下载共用）
.progress-container {
  grid-column: 1 / -1;
  height: 180px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  background-color: #f9fafb;
  border-radius: 8px;
  margin: 0 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.progress-row {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 15px;
  padding: 0 10px;
}

// 进度条信息样式
.progress-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.file-status {
  font-size: 14px;
  color: #165dff;
  font-weight: 500;
  text-align: center;
  padding: 0 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep .el-progress {
  flex: 1;
  height: 18px !important;
}

::v-deep .el-progress-bar__inner {
  background-color: #165dff;
  transition: width 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  border-radius: 9px;
}

::v-deep .el-progress-bar__outer {
  background-color: #e8e8e8;
  border-radius: 9px;
}

.cancel-upload,
.cancel-download {
  font-size: 20px;
  color: #ff4d4f;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 5px;
  border-radius: 50%;

  &:hover {
    color: #f5222d;
    transform: scale(1.1) rotate(9deg);
    background-color: rgba(245, 34, 45, 0.1);
  }
}

// 竣工结算成果文件上传提示对话框样式
::v-deep .upload-tip-dialog {
  .el-dialog__header {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #f0f0f0;

    .el-dialog__title {
      font-size: 16px;
      font-weight: 600;
      color: #1d2129;
    }
  }

  .el-dialog__body {
    padding: 30px 20px;

    .tip-content {
      .tip-message {
        font-size: 14px;
        color: #4e5969;
        line-height: 2;
        text-align: center;
        margin: 15px 0;
      }
    }
  }

  .el-dialog__footer {
    padding: 10px 20px 20px;
    border-top: 1px solid #f0f0f0;

    .dialog-footer {
      display: flex;
      justify-content: center;
      gap: 20px;

      .el-button {
        min-width: 100px;
        font-size: 14px;
      }
    }
  }
}

// 抽屉样式
.review-divider ::v-deep .el-drawer__header {
  padding: 0;
  height: 60px;
  padding-left: 20px;
  margin-bottom: 0px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
}

::v-deep .drawer-container {
  display: flex;
  height: calc(100% - 0px);
  gap: 30px;
  padding: 3px;

  .left {
    width: 75%;
    height: 100%;
    background-color: #fafafa;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  .empty {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    color: #86909c;
    flex-direction: column;
    gap: 15px;

    &::before {
      content: '';
      display: block;
      width: 60px;
      height: 60px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2386909c' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3Cline x1='12' y1='8' x2='12' y2='12'%3E%3C/line%3E%3Cline x1='12' y1='16' x2='12.01' y2='16'%3E%3C/line%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    width: 25%;

    .title {
      font-size: 16px;
      color: #409EFF;
      margin-top: 10px;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 8px;

      &::before {
        content: '';
        display: block;
        width: 4px;
        height: 16px;
        background-color: #409EFF;
        border-radius: 2px;
      }
    }
  }

  .el-menu-item {
    height: 45px;
    line-height: 45px;
    transition: all 0.2s ease;

    &:hover {
      background-color: #f5f7fa;
    }

    &.is-active {
      background-color: #e6f7ff;
      color: #1890ff;
      border-left: 3px solid #1890ff;
    }
  }
}

.el-divider--horizontal {
  margin: 8px 0;
}

// 响应式设计
@media (max-width: 1200px) {
  .Jj_annex_block {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }
}

@media (max-width: 992px) {
  ::v-deep .drawer-container {
    flex-direction: column;

    .left,
    .right {
      width: 100%;
    }

    .left {
      height: 50%;
      margin-bottom: 20px;
    }

    .right {
      height: 50%;
      overflow-y: auto;
    }
  }
}

@media (max-width: 768px) {
  .Jj_annex_block {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 15px;
    padding: 15px 0;
  }

  .file-card {
    min-width: 140px;
  }

  .file-box {
    height: 150px;
  }

  .progress-container {
    height: 150px;
  }
}

@media (max-width: 480px) {
  .Jj_annex_block {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 10px;
  }

  .file-card {
    min-width: 120px;
  }

  .file-box {
    height: 120px;
  }

  .action-buttons {
    gap: 5px;
  }

  .btn-preview,
  .btn-download,
  .btn-delete {
    font-size: 12px;
    padding: 4px 0;
  }

  .upload-area i {
    font-size: 24px;
  }

  .upload-text,
  .format-tip,
  .size-tip {
    font-size: 11px;
  }

  ::v-deep .drawer-container {
    padding: 10px;
    gap: 15px;
  }
}
</style>